import { Radio as TrussRadio } from "@trussworks/react-uswds";
import cn from "classnames";

// styles
import styles from "./Radio.module.scss";

export type RadioProps = {
  id: string;
  name: string;
  label: React.ReactNode;
  className?: string;
  inputRef?:
    | string
    | ((instance: HTMLInputElement | null) => void)
    | React.RefObject<HTMLInputElement>
    | null
    | undefined;
  tile?: boolean;
  labelDescription?: React.ReactNode;
} & JSX.IntrinsicElements["input"];

export default function Radio(props: RadioProps) {
  const { className, ...rest } = props;

  const radioClasses = cn(styles["radio-root"], {
    [className]: className,
  });

  return <TrussRadio className={radioClasses} {...rest} />;
}
